import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=20db0298&scoped=true&"
import script from "./ReadMore.vue?vue&type=script&lang=ts&"
export * from "./ReadMore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20db0298",
  null
  
)

export default component.exports